
import React from 'react';
import './InputFormsForAnswers.scss';
import {  openDeleteInputFormsForNotePart, notePartDelete } from '../../../adminSlice';

export default class DeleteInputFormsForNotePart  extends React.Component {
    constructor(props) {
        super(props);
        
       
       this.onSend = this.onSend.bind(this);
       this.onClose = this.onClose.bind(this);
    }

  
 // CLICK OK
onSend() {
        const { dispatch } = this.props;
       


        const item = {
            note_id: this.props.adminState.selectedIdNote,
            note_part: this.props.adminState.selectedPartNote,
                        
        }
    
        console.log(item);
       dispatch(notePartDelete(item));
       dispatch(openDeleteInputFormsForNotePart()); 
        
}


// CLOSE FORM
onClose() {
    const { dispatch } = this.props;
    dispatch(openDeleteInputFormsForNotePart());

}

   renderTable() {
       return null;
   }
   
    render() {
        //console.log(this.props.adminState.openInputForms);
     if (this.props.adminState.openDeleteInputFormsForNotePart) {
        return(
            <div className="InputFormsForAnswers">
                           


             <p><b>Вы действительно хотите удалить данную часть?</b></p>
             
             <button onClick={this.onSend}>Да</button>
             <button onClick={this.onClose}>Отмена</button>
            </div>
        )
     } else return null;
       
     

        
    }
}
